import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import angular from "../assets/img/angular.png";
import sql from "../assets/img/sql.png";
import webtools from "../assets/img/webtools.png";
import colorSharp from "../assets/img/color-sharp.png";
import figma from "../assets/img/figma.png";
import git from "../assets/img/git.png";
import react from "../assets/img/react.png";
import unity from "../assets/img/unity.png";
export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>
                        <p>I am a software developer skilled in Unity and web development, <br></br>proficient in C#, HTML, CSS, JS  and various programming languages.</p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src={unity} alt="Unity" />
                                
                            </div>
                            <div className="item">
                                <img src={webtools} alt="Web Tools" />
                            </div>
                            <div className="item">
                                <img src={react} alt="React" />
                            </div>
                            <div className="item">
                                <img src={angular} alt="Angular" />
                            </div>
                            <div className="item">
                                <img src={figma} alt="Figma" />
                            </div>
                            <div className="item">
                                <img src={git} alt="Git" />
                            </div>
                            <div className="item">
                                <img src={sql} alt="SQL" />
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Background" />
    </section>
  )
}